export interface Category {
  name: string;
  displayName: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    displayName: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
  },
  {
    name: 'Hoodies/Sweaters',
    displayName: 'Hoodies &amp; Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
  },
  {
    name: 'T-Shirts',
    displayName: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-air-line',
  },
  {
    name: 'Jackets',
    displayName: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-honour-line',
  },
  {
    name: 'Pants/Shorts',
    displayName: 'Pants &amp; Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-pantone-line',
  },
  {
    name: 'Headwear',
    displayName: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-bear-smile-line',
  },
  {
    name: 'Sets',
    displayName: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
  },
  {
    name: 'Underwear/Underpants',
    displayName: 'Underwear &amp; Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shirt-line',
  },
  {
    name: 'Jersey',
    displayName: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-team-line',
  },
  {
    name: 'Accessories',
    displayName: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-vip-diamond-line',
  },
  {
    name: 'Bags',
    displayName: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
  },
  {
    name: 'Belts',
    displayName: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
  },
  {
    name: 'Perfumes',
    displayName: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-2-line',
  },
  {
    name: 'Other Stuff',
    displayName: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
  },
];